export default class BrowserFileDownload {
    constructor(file, contentDisposition) {
        this._file = file;
        this._contentDisposition = contentDisposition;
    }

    fileName() {
        const encodedFileName = this._contentDisposition.match(/filename\*=utf-8''([^;]+)/i);
        if (encodedFileName) {
            return decodeURIComponent(encodedFileName[1]);
        }
        return this._contentDisposition.match(/filename="([^"]+)"/i)[1];
    }

    save() {
        const objectUrl = URL.createObjectURL(this._file);
        const downloadLink = document.createElement('a');
        downloadLink.href = objectUrl;
        downloadLink.download = this.fileName();
        downloadLink.click();
        URL.revokeObjectURL(objectUrl);
    }
}
